/**
 * Phone number formatting utility
 * Formats phone numbers as (XXX) XXX-XXXX
 */

/**
 * Formats a phone number string to (XXX) XXX-XXXX format
 * @param value - The raw phone number input
 * @returns Formatted phone number string
 */
export const formatPhoneNumber = (value: string): string => {
  // Remove all non-numeric characters
  const phoneNumber = value.replace(/\D/g, "");

  // Format based on length
  if (phoneNumber.length === 0) return "";
  if (phoneNumber.length <= 3) return phoneNumber;
  if (phoneNumber.length <= 6) return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};
